module.exports = __webpack_public_path__ + "img/3.60d8c3db.jpg";